module.exports = __webpack_public_path__ + "img/pending.76caddce.png";